import React, { Component } from 'react';
import { Card, Table, Container } from "reactstrap";

class RXInfo extends Component {
    constructor() {
        super();
        this.state = {
            counsellingNotes: '',
            notes: ''
        };
        this.onChange = this.onChange.bind(this);
    };

    onChange = e =>
        this.setState({
            [e.target.name]: e.target.value
        });

    render() {
        const rxInfo = this.props.draft;
        const currentRefillCount = rxInfo.rxInfo.prescriptionNumber.split('-')[1]
        //console.log(currentRefillCount);
        return (
            <Container>
                <Card style={this.props.style}>
                    <Table>
                        <tbody className="font-style">
                            <tr>

                                <td className="font-bigger"><span className="text-info font-bigger">Name : </span>{rxInfo.rxInfo.rxName} </td>
                                <td className="font-bigger"><span
                                    className="text-info font-bigger">Strength : </span><span
                                        className="text-lowercase font-bigger">{rxInfo.rxInfo.strength}</span>
                                </td>

                            </tr>
                            <tr>
                                <td colSpan="2" className="font-bigger"><span
                                    className="text-info font-bigger">Directions : </span>{rxInfo.rxInfo.rxDirectionsToUse}
                                </td>
                            </tr>
                            <tr>

                                <td className="font-bigger"><span className="text-info font-bigger">Qty : </span>{rxInfo.rxInfo.quantity}</td>
                                <td className="font-bigger"><span className="text-info font-bigger">Days Supply : </span>{rxInfo.rxInfo.daysSupply}
                                </td>
                            </tr>
                            <tr>
                                <td className="font-bigger"><span className="text-info font-bigger">NDC : </span >***{rxInfo.rxInfo.ndcNumber.substring(1, 5)}</td>
                                <td><span
                                    className="text-info">Prescription Start Date : </span>{rxInfo.rxInfo.prescriptionStartDate}
                                </td>

                            </tr>
                            <tr>
                                <td><span
                                    className="text-info">Prescription End Date : </span>{rxInfo.rxInfo.prescriptionEndDate}
                                </td>
                                <td><span
                                    className="text-info">Prescription Fill Date : </span>{rxInfo.rxInfo.dateFilled}
                                </td>
                            </tr>
                            <tr>
                                <td><span className="text-info">Prescriber : </span>{rxInfo.prescriberInfo.name}
                                </td>
                                <td><span className="text-info">Prescriber NPI: </span></td>
                            </tr>
                            <tr>
                                <td><span
                                    className="text-info">Current Refill : </span>{currentRefillCount}
                                </td>
                                <td><span
                                    className="text-info">Refills Remaining : </span>{rxInfo.rxInfo.maximumRefillsAllowed - currentRefillCount}
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Card>
            </Container>
        );
    }
}

export default RXInfo;
